/**
 * jQuery object
 * @external jQuery
 * @see {@link http://api.jquery.com/jQuery/}
 */
;(function ($) {
    $.siteLoader = {
        /**
         * @memberOf siteLoader
         * @param {string} selector
         */
        init(selector) {
            let self = this;

            $(window).on('load', function () {
                let $overlay = $(selector),
                    overlay_length = $overlay.length;

                if (overlay_length) {
                    self.toggle($overlay, 'hide');
                }
            });
        },

        /**
         * @memberOf siteLoader
         * @param $selector
         * @param {string} action
         * @param triggerBefore
         * @param triggerAfter
         */
        toggle($selector, action, triggerBefore = null, triggerAfter = null) {
            $(window).trigger('site:loaded');

            if(action === 'hide') {
                if(triggerBefore) {
                    $(window).trigger(triggerBefore);
                }

                $selector.stop(true, true).fadeOut(1000, function () {
                    if(triggerAfter) {
                        $(window).trigger(triggerAfter);
                    }
                });
            }

            if(action === 'show') {
                if(triggerBefore) {
                    $(window).trigger(triggerBefore);
                }

                $selector.stop(true, true).fadeIn(1000, function () {
                    if(triggerAfter) {
                        $(window).trigger(triggerAfter);
                    }
                });
            }

            $(window).trigger('site:loaded');
        }
    };
}(jQuery));
